// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1MI6g","footer":"Form_footer___AMSo"};